/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminVoucherCreateDTO } from '../models/AdminVoucherCreateDTO';
import type { CommunicationTrackingEventOut } from '../models/CommunicationTrackingEventOut';
import type { ConvertToVoucherDTO } from '../models/ConvertToVoucherDTO';
import type { EditVoucherDTO } from '../models/EditVoucherDTO';
import type { SendVoucherDTO } from '../models/SendVoucherDTO';
import type { VoucherCreateDTO } from '../models/VoucherCreateDTO';
import type { VoucherOut } from '../models/VoucherOut';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VoucherService {
  /**
   * Create Voucher
   * @param requestBody
   * @returns VoucherOut Successful Response
   * @throws ApiError
   */
  public static createVoucher(requestBody: VoucherCreateDTO): CancelablePromise<VoucherOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/voucher',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Edit Voucher
   * @param requestBody
   * @returns VoucherOut Successful Response
   * @throws ApiError
   */
  public static editVoucher(requestBody: EditVoucherDTO): CancelablePromise<VoucherOut> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/voucher',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Voucher
   * @param voucherCode
   * @returns VoucherOut Successful Response
   * @throws ApiError
   */
  public static getVoucher(voucherCode: string): CancelablePromise<VoucherOut> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/voucher',
      query: {
        voucher_code: voucherCode,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Archive Voucher
   * @param voucherId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static archiveVoucher(voucherId: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/voucher',
      query: {
        voucher_id: voucherId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Admin Voucher
   * @param requestBody
   * @returns VoucherOut Successful Response
   * @throws ApiError
   */
  public static createAdminVoucher(requestBody: AdminVoucherCreateDTO): CancelablePromise<VoucherOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/voucher/admin',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Voucher By Id
   * @param voucherId
   * @returns VoucherOut Successful Response
   * @throws ApiError
   */
  public static getVoucherById(voucherId: string): CancelablePromise<VoucherOut> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/voucher/by_id',
      query: {
        voucher_id: voucherId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Voucher Communications Tracking
   * @param voucherId
   * @returns CommunicationTrackingEventOut Successful Response
   * @throws ApiError
   */
  public static getVoucherEmailCommunications(
    voucherId: string,
  ): CancelablePromise<Array<CommunicationTrackingEventOut>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/voucher/communications-tracking',
      query: {
        voucher_id: voucherId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Vouchers
   * @param page Page number
   * @param perPage Items per page
   * @param search Search value
   * @returns VoucherOut Successful Response
   * @throws ApiError
   */
  public static getVouchers(
    page: number = 1,
    perPage: number = 10,
    search?: string,
  ): CancelablePromise<Array<VoucherOut>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/voucher/list',
      query: {
        page: page,
        per_page: perPage,
        search: search,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Convert To Voucher
   * @param requestBody
   * @returns VoucherOut Successful Response
   * @throws ApiError
   */
  public static convertToVoucher(requestBody: ConvertToVoucherDTO): CancelablePromise<VoucherOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/voucher/convert_to_voucher',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Send Voucher
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public static sendVoucher(requestBody: SendVoucherDTO): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/voucher/send_voucher',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
